'use client';

import type { ReactNode } from 'react';
import { useEffect, useState, createContext, useContext, useMemo } from 'react';
import type { ISession } from 'shared/lib/auth/types';
import { getSession } from 'shared/lib/auth/actions';
const SessionContext = createContext<ISession | null>(null);
export const useSession = () => useContext(SessionContext);
const refreshInterval = 4 * 60 + 30; // 4 minutes + 30 seconds

export function SessionProvider({
  children,
  value
}: {
  children: ReactNode;
  value: ISession;
}) {
  const [session, setSession] = useState<null | ISession | undefined>(null);

  // const { data } = useQuery({
  //   queryKey: ['session'],
  //   queryFn: async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.NEXT_PUBLIC_URL}/api/login/refresh`,
  //         {
  //           method: 'GET',
  //           credentials: 'include',
  //         }
  //       );
  //
  //       if (!response.ok) {
  //         throw new Error('Failed to refresh token');
  //       }
  //
  //       const session = await response.json();
  //       // const session = await getSession();
  //       // setSession(session);
  //       return session;
  //     } catch (error) {
  //       // eslint-disable-next-line no-console
  //       console.error('Error refreshing access token:', error);
  //     }
  //   },
  //   refetchInterval: refreshInterval * 1000,
  // });

  useEffect(() => {
    async function handleRefreshToken() {
      try {
        const session = await getSession();
        if (session === null || session === undefined) return;
        const response = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/login/refresh`, {
          method: 'POST',
          body: JSON.stringify(session),
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error('Failed to refresh token');
        }
        return await response.json();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error refreshing access token:', error);
      }
    }
    const refetchIntervalTimer = setInterval(async () => {
      const session = await handleRefreshToken();
      setSession(session);
      // console.debug('Refreshing token');
      // console.debug(res.refresh_expires_in);
    }, refreshInterval * 1000);
    return () => clearInterval(refetchIntervalTimer);
  }, []);
  const sessionValue = useMemo(() => session || value, [session, value]);
  return <SessionContext.Provider value={sessionValue} data-sentry-element="unknown" data-sentry-component="SessionProvider" data-sentry-source-file="session-provider.tsx">
      {children}
    </SessionContext.Provider>;
}